import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ReportService } from '../../services/report.service';
import { ReportSummary } from '../../models/report-summary.model';
import { Discrepancy } from '../../models/report-discrepancies.model';
import * as moment from 'moment';
import { RoutingService } from '../../../routing/services/routing.service';
import { EventsService } from '../../../events/services/events.service';
import { Report } from '../../models/report.model';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-report-summary-component',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss', '../../scss/report-common.scss']
})

export class ReportSummaryComponent implements OnInit, OnDestroy {
  reportSummary: ReportSummary;
  report: Report;
  discrepancies: Discrepancy[];
  durationString = '';
  public isCollapsed = true;
  private reportGroupByField = 0;
  private onProjectListUpdateSubscription: Subscription;

  private projectId;
  private summaryLoaded = false;

  constructor(private routingService: RoutingService, private reportService: ReportService,
    private router: Router, private activeRoute: ActivatedRoute, private eventsService: EventsService) { }

  ngOnInit() {
    this.projectId = this.activeRoute.snapshot.params['id'];

    if (this.projectId === 0) {
      return;
    }
    
    this.report = this.reportService.getReport(this.projectId);

   if (this.projectId !== 0 && this.reportSummary === undefined) {
      this.onProjectListUpdateSubscription = this.reportService.onProjectListUpdate.subscribe((response) => {
        this.reportService.getReportSummary(this.projectId, (summary) => {
          this.reportSummary = summary;
          this.summaryLoaded = true;
          this.report = this.reportService.getReport(this.projectId);
              if (this.reportSummary) {
                this.durationString = this.calculateReportDuration(this.reportSummary.durationInSeconds);
                this.discrepancies = this.reportService.getReportDiscrepancies(this.projectId);
              }
          });
        });
        this.reportService.getLatestReports();
    }
  }

  ngOnDestroy() {
    if (this.onProjectListUpdateSubscription) {
      this.onProjectListUpdateSubscription.unsubscribe();
    }
  }

  shouldShowDownloadTypes() {
    return this.report
      ? Report.SummaryPdfSupportedReports.some(r => this.report.reportTypeId == r.id)
      : false;
  }

  displayDownloadOptions() {
    return this.report.reportStatusId === 1
      ? true
      : false;
  }  

  calculateReportDuration(duration) {
    if (!duration || duration < 5) {
      return 'A few seconds';
    }

    if (duration < 60) {
      return duration + ' seconds';
    }

    if (duration < 600) {
      const numberOfMinutes = Math.floor(duration / 60);
      const minuteString = numberOfMinutes === 1 ? ' minute, ' : ' minutes, ';
      return numberOfMinutes + minuteString + (duration - (numberOfMinutes * 60)) + ' seconds';
    }

    if (duration < 3600) {
      const numberOfMinutes = Math.floor(duration / 60);
      return numberOfMinutes + ' minutes';
    }

    const numberOfHours = Math.floor(duration / 3600);
    const secondsRemaining = duration - (numberOfHours * 3600);
    const numberOfMinutes = Math.floor(secondsRemaining / 60);
    const hourString = numberOfHours === 1 ? ' hour, ' : ' hours, ';
    return numberOfHours + hourString + numberOfMinutes + ' minutes.';
  }

    downloadDiscrepancy(id: number) {
      this.eventsService.recordDiscrepanctReportDownloadedEvent();
      this.router.navigate(['download', id, { 'isDiscrepancyReport': 'true' }]);
    }

    downloadReport(id: number, name: string, reportType: string, reportGroupByField: number) {
      let reportEventType = reportType + (reportGroupByField != 0 ? ' Summary' : '');
      this.eventsService.recordReportDownloadedEvent(reportEventType);
      this.router.navigate(['download', id, { 'name': name, 'summaryReportGroupByField' : reportGroupByField }]);
    }

    shouldDisplayError() {
      return (!this.refreshInProgress() && this.loadingSummaryComplete() && (this.reportSummary === undefined || this.reportSummary.projectId === undefined));
    }

    displayElement (fieldName) {
      return this.loadingComplete() && !this.reportSummary.hiddenElements.some(item => item.toLowerCase() === fieldName.toLowerCase())
    }

    refreshInProgress() {
      return this.reportService.isReportRefreshInProgress ;
    }

    loadingSummaryComplete() {
      return this.summaryLoaded;
    }

    loadingComplete() {
      return (!this.refreshInProgress() && this.loadingSummaryComplete() && this.projectId !== undefined);
    }

    getUnsoldVehiclesCount() {
      if (this.discrepancies.length > 0) {
        const discrepancyEntries = this.discrepancies.filter((d) => d.description === 'Vehicle was excluded from the results');
        if (discrepancyEntries.length > 0) {
          const discrepancyEntry = discrepancyEntries[0];
          return discrepancyEntry.discrepancyCount;
        }
        return 0;
      }
      return 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/report/components/summary/report-summary.component.ts